module.exports = __webpack_public_path__ + "img/05.b6627147.jpg";